import { render, staticRenderFns } from "./CoachDashboard.vue?vue&type=template&id=32fd5e6b&"
import script from "./CoachDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoachDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports